import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import logo from '../assets/images/smallpp.png';
import logo2 from '../assets/images/remax.png';
import { FaBars, FaTimes } from 'react-icons/fa';

function Navbar() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const handleLinkClick = (e, id) => {
    e.preventDefault();
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        scrollToSection(id);
      }, 100);
    } else {
      scrollToSection(id);
    }
    setIsMobileMenuOpen(false);
  };

  const scrollToSection = (id) => {
    const targetSection = document.getElementById(id);
    if (targetSection) {
      window.scrollTo({
        top: targetSection.offsetTop - 80,
        behavior: 'smooth',
      });
    }
  };

  const navLinks = [
    { id: 'home', label: 'Home' },
    { id: 'about', label: 'About' },
    { id: 'services', label: 'Services' },
    { id: 'contact', label: 'Contact' },
  ];

  return (
    <nav className="fixed top-0 left-0 w-full bg-white shadow-md z-50 flex items-center justify-between px-6 py-4 md:px-12">
      {/* Left Logo and Name */}
      <div className="flex items-center">
        <img src={logo} alt="Profile" className="w-12 h-12 border-2 border-gray-300" />
        <span className="text-xl font-bold ml-4 text-gray-800">Azhar Rehman</span>
      </div>

      {/* Desktop Navigation Links */}
      <ul className="hidden md:flex gap-8 items-center text-gray-700 font-medium">
        {navLinks.map((link) => (
          <li key={link.id}>
            <a
              href={`#${link.id}`}
              onClick={(e) => handleLinkClick(e, link.id)}
              className="hover:text-blue-500 transition"
            >
              {link.label}
            </a>
          </li>
        ))}
      </ul>

      <div className="hidden md:flex items-center">
  <a 
    href="https://www.remax.ca/ns/azhar-rehman-p102419603-ag" 
    target="_blank" 
    rel="noopener noreferrer"
  >
    <img 
      src={logo2} 
      alt="Remax Logo" 
      className="h-12" // Removed border and set clean height
    />
  </a>
</div>


      {/* Mobile Menu Button */}
      <button
        className="md:hidden text-gray-800"
        onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
      >
        {isMobileMenuOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
      </button>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <ul className="absolute top-full left-0 w-full bg-white shadow-md flex flex-col items-center py-4 text-gray-800">
          {navLinks.map((link) => (
            <li key={link.id} className="py-2">
              <a
                href={`#${link.id}`}
                onClick={(e) => handleLinkClick(e, link.id)}
                className="hover:text-blue-500 transition"
              >
                {link.label}
              </a>
            </li>
          ))}
        </ul>
      )}
    </nav>
  );
}

export default Navbar;
